import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { enrollStudentToBatch, resetEnrollStudentToBatch } from "./enroll-student-to-batch";

const initialState: ProcessingState = { processing: "idle" };

export const enrollStudentToBatchReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(enrollStudentToBatch.pending, () => ({ processing: "pending" }));
  builder.addCase(enrollStudentToBatch.fulfilled, () => ({ processing: "success" }));
  builder.addCase(enrollStudentToBatch.rejected, () => ({ processing: "failed" }));
  builder.addCase(resetEnrollStudentToBatch, () => initialState);
});
